<section class="{{ customClass }}"> <hr class="details-divider"/> <div>* {{ requiredFieldMessage }}</div> </section>